// import BlankLayout from "@/layouts/blank";
import MasterLayout from "@/layouts/master";
import NotFound from "@/views/not-found";
import authRoutes from "./authRoutes.js";
import adminRoutes from "./adminRoutes.js";
import afiliacionRoutes from "./afiliacionRoutes.js";
import afiliadoRoutes from "./afiliadoRoutes.js";
import alertasRoutes from "./alertasRoutes.js";
import aportesRoutes from "./aportesRoutes.js";
import archivoRoutes from "./archivoRoutes.js";
import informesRoutes from "./informesRoutes.js";
import serviciosRoutes from "./serviciosRoutes.js";
import appsRoutes from "./appsRoutes.js";

const baseRoutes = [{
        path: "/admin",
        component: MasterLayout,
        children: [{
            path: "/home",
            name: "admin.home",
            component: () =>
                import ("@/views/home.vue")
        }]
    },
    {
        path: "/",
        redirect: "/home"
    },
    {
        path: "*",
        name: "notFound",
        component: NotFound
    }
]

const importedRoutes = [
    authRoutes,
    adminRoutes,
    afiliacionRoutes,
    afiliadoRoutes,
    alertasRoutes,
    aportesRoutes,
    archivoRoutes,
    informesRoutes,
    serviciosRoutes,
    appsRoutes
];

const routes = importedRoutes.reduce(function(prev, moduleRoute) {
    return prev.concat(moduleRoute);
}, baseRoutes)


export default routes;